import { render } from "./ViewMyPayslips.vue?vue&type=template&id=74de6690&scoped=true"
import script from "./ViewMyPayslips.vue?vue&type=script&lang=js"
export * from "./ViewMyPayslips.vue?vue&type=script&lang=js"

import "./ViewMyPayslips.vue?vue&type=style&index=0&id=74de6690&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74de6690"]])

export default __exports__